import { Component, computed, input } from '@angular/core';
import { AliceAnimationsComponent } from '../alice-animations/alice-animations.component';
import { TranslocoDirective } from '@jsverse/transloco';
import { getTranslateModel, TranslateModel } from '@futura/futura-ui/core';
import { COMPONENT_STATE, ComponentState, GhostStateFragmentDirective } from '@futura/futura-ui/ghost';

@Component({
  selector: 'app-alice-comment',
  standalone: true,
  imports: [AliceAnimationsComponent, TranslocoDirective, GhostStateFragmentDirective],
  templateUrl: './alice-comment.component.html',
  styleUrl: './alice-comment.component.scss',
})
export class AliceCommentComponent {
  public readonly state = input<ComponentState>(COMPONENT_STATE.NONE);
  public readonly comment = input<string | TranslateModel>('');

  public readonly translatedComment = computed(() => getTranslateModel(this.comment()));
}
